import { styled } from '@streem/ui-react';

export const PageWrapper = styled.article`
    margin: ${props => props.theme.space[4]}px ${props => props.theme.space[5]}px;
`;
